export { ImageToBackgroundEntryPoint } from './scope';
